import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import DailyReport from "./DailyReport";
import MonthlySummary from "./MonthlySummary";
import ChartComponent from "./ChartComponent";
import "./Report.css";

interface ReportProps {
  theme?: "dark" | "light";
}

const Report: React.FC<ReportProps> = ({ theme = "light" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const activeKey = params.get("tab") || "daily";

  return (
    <div className="report-shell">
      <Tabs
        activeKey={activeKey}
        items={[
          { key: "daily", label: "Өдрийн тайлан", children: <DailyReport /> },
          { key: "monthly", label: "Сарын тайлан", children: <MonthlySummary /> },
          { key: "charts", label: "График", children: <ChartComponent theme={theme} /> },
        ]}
        onChange={(key) => navigate(`/Report?tab=${key}`)}
      />
    </div>
  );
};

export default Report;
